import { DomainItem } from '@anm/api/modules/customDomains';
import ActionsDropdown from '@anm/components/ActionsDropdown';
import RadioButton from '@anm/components/form/RadioButton';
import { getDropdownActions } from '@anm/helpers/dropdownActions';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { landingsActions, landingsSelectors } from '../../../../store/modules/landings';
import { domainsActions } from '../../../../store/modules/domains';
import { ListItemWrapper, LeftColumn, RightColumn, StatusLabel } from '../List/styles';

type ListItemProps = {
  item: DomainItem;
  handleDomainSelect: (host: string) => void;
  selectedDomain?: string;
};

const Listitem: FC<ListItemProps> = ({ item, selectedDomain, handleDomainSelect }) => {
  const dispatch = useDispatch();
  const webinar = useSelector(landingsSelectors.selectLanding);

  const handleRemoveDomain = () => {
    if (selectedDomain === item.Host && webinar) {
      dispatch(
        landingsActions.saveLanding({
          ...webinar,
          parameters: {
            ...webinar?.parameters,
            customDomain: ''
          }
        })
      );
    }

    dispatch(domainsActions.removeDomain(item.Host));
  };

  return (
    <ListItemWrapper key={item.Host}>
      <LeftColumn>
        <RadioButton
          value={item.Host}
          name="custom-domain"
          label={item.Host}
          isChecked={selectedDomain === item.Host}
          onChange={handleDomainSelect}
        />
      </LeftColumn>
      <RightColumn>
        <StatusLabel status={item.State}>{item.State === 'OK' ? 'verified' : 'verifying'}</StatusLabel>
        <ActionsDropdown openerVariant="dots" actions={getDropdownActions({ onDelete: handleRemoveDomain })} />
      </RightColumn>
    </ListItemWrapper>
  );
};

export default Listitem;
